export const isDesktop = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.process?.type === 'renderer') {
    return true;
  }

  // fallback
  return navigator.userAgent.toLowerCase().includes('electron');
};

export function detectOS() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('win')) {
    return 'windows';
  }

  if (userAgent.includes('mac')) {
    return 'mac';
  }

  return 'unknown';
}

export const isSafari = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isIOS = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isAndroid = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /Android/i.test(navigator.userAgent);
};

export const isMobile = () => isIOS() || isAndroid();
